import axios from 'axios';

let token = localStorage.getItem("token");
if (token) {
  token = token.replace(/"/g, '');
}

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,

  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
    "Access-Control-Allow-Headers": "Content-Type",

  }
});



// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      config.headers.Authorization = `Bearer ${storedToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);




// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const expiredToken = localStorage.getItem('token');
        const refreshResponse = await api.post('/api/Authenticate/RefreshToken', { expiredToken, refreshToken });
        const newToken = refreshResponse.data.token;
        const newRefreshToken = refreshResponse.data.refreshToken;
        localStorage.setItem('token', newToken);
        localStorage.setItem('refreshToken', newRefreshToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axios(originalRequest);
      } catch (err) {
        console.error("Error refreshing token: ", err);
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);




export default api;